export class GrandTotal {
    dealerShips: Object;
    targetBudget: number;
    constructor(dealerShips, targetBudget) {

        this.dealerShips = dealerShips;
        this.targetBudget = targetBudget;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/budget/grand-total.ts